import { render } from "./nurse_dashboard.vue?vue&type=template&id=1792f510&scoped=true"
import script from "./nurse_dashboard.js?vue&type=script&lang=js"
export * from "./nurse_dashboard.js?vue&type=script&lang=js"

import "./nurse_dashboard.vue?vue&type=style&index=0&id=1792f510&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1792f510"]])

export default __exports__